export default __webpack_public_path__ + "static/media/OSPUNCPBA-orange.b2f2e6dd.svg";